import type { FC, ReactElement } from 'react';

import type { ICoreTimings } from '../../../store/slices/config/types';
import { GameStatus } from '../../../store/slices/game/types';

import { LastBetsRendererConnected } from './renderers/LastBetsRendererConnected';
import { PlaceBetsRendererConnected } from './renderers/PlaceBetsRendererConnected';

export interface TrafficLightRendererProps {
  timer?: ReactElement;
}

export interface TrafficLightConfigType {
  label: string;
  rendersTimer: boolean;
  attrs?: string[];
  color?: 'inverse' | 'default' | string;
  isLTR?: boolean;
  render?: FC<TrafficLightRendererProps>;
  style?: 'warning' | 'danger' | 'mega' | 'none' | 'default' | string;
  /** Scheduled status change */
  scheduledStatusChange?: {
    /** Timeout before status change in ms */
    timeout: number | keyof ICoreTimings | ((timings: ICoreTimings) => number);
    /** Next status after timeout */
    nextStatus: string;
  };
}

export const baseTrafficLightConfig: Record<string, TrafficLightConfigType> = {
  WELCOMEMSG: {
    label: 'WELCOMEMSG',
    rendersTimer: false,
    style: 'none',
  },
  WAITFORNEXTGAME: {
    label: 'WAITFORNEXTGAME',
    rendersTimer: false,
    style: 'none',
  },
  BETSCLOSED: {
    label: 'BETS_CLOSED',
    rendersTimer: false,
    style: 'none',
  },
  BETSACCEPTED: {
    label: 'BETS_ACCEPTED',
    rendersTimer: false,
    style: 'default',
  },
  PLACEYOURBETS: {
    label: 'PLACE_YOUR_BETS',
    rendersTimer: true,
    render: PlaceBetsRendererConnected,
    scheduledStatusChange: {
      timeout: (timings) => -timings.bettingLastCall,
      nextStatus: GameStatus.LastBets,
    },
    style: 'default',
  },
  LASTBETS: {
    label: 'LASTBETS',
    render: LastBetsRendererConnected,
    rendersTimer: true,
    style: 'warning',
  },
  BETSREJECTED: {
    label: 'BETS_REJECTED',
    rendersTimer: false,
    style: 'danger',
  },
  NOTALLBETSACCEPTED: {
    label: 'NOT_ALL_BETS_ACCEPTED',
    rendersTimer: false,
    style: 'danger',
  },
  GAMECANCELLED: {
    label: 'GAMECANCELLED',
    rendersTimer: false,
    style: 'danger',
  },
  DRAWING: {
    label: 'DRAWING: no translation',
    rendersTimer: false,
    style: 'none',
  },
  DEALING: {
    label: 'DEALING',
    rendersTimer: false,
    style: 'none',
  },
  MEGAMULTIPLIERS: {
    label: 'MEGAMULTIPLIERS',
    rendersTimer: false,
    style: 'mega',
  },
  TUMBLING: {
    label: 'TUMBLING_CAPS',
    rendersTimer: false,
    style: 'none',
  },
  BONUSROUND: {
    label: 'DECISIONTITLE',
    rendersTimer: true,
    style: 'default',
  },
  YOUWIN: {
    label: 'YOU_WIN',
    rendersTimer: false,
    style: 'default',
  },
  RESULT: {
    label: 'RESULT',
    rendersTimer: false,
    style: 'none',
  },
  GREEN: {
    label: 'GREEN (what is that?)',
    rendersTimer: false,
    style: 'none',
  },
  PUSH: {
    label: 'PUSH',
    rendersTimer: false,
    style: 'none',
  },
  DEALERWINS: {
    label: 'DEALER_WINS',
    rendersTimer: false,
    style: 'none',
  },
  SUMTO: {
    label: 'SUM_TO (What is that?)',
    rendersTimer: false,
    style: 'none',
  },
};
